/** @format */

import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import FailedEngineAnalysisRequests from "./failed-engine-analysis-requests";
import FailedPartAnalysisRequests from "./failed-part-analysis-request";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

const QualityApproverPendingRequests = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{
            marginTop: "10px",
            minHeight: "32px",
            "& .MuiTab-root": {
              minHeight: "32px",
              fontSize: "12px",
              padding: "4px 8px",
            },
            "& .MuiTabs-indicator": {
              height: "2px",
            },
          }}
        >
          <Tab label="Failed Engines Analysis Request" />
          <Tab label="Failed Parts Analysis Request" />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <FailedEngineAnalysisRequests />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <FailedPartAnalysisRequests />
      </TabPanel>
    </Box>
  );
};

export default QualityApproverPendingRequests;
